import React from "react";

import NavBar from "../../components/NavBar/NavBar";
import Pricing from "../../components/Pricing/Pricing";
import Prefer from "../../components/Prefer/Prefer";
import Offices from "../../components/Offices/Offices";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

import Order from "../../components/Order/Order";

import "./Quote.css";

const Quote = () => {
  if (window.location.hash !== "#user-info")
    return (
      <>
        <NavBar />
        <Pricing />
        <Prefer />
        <Offices />
        <ContactUs />
        <Footer />
      </>
    );
  else return <Order />;
};

export default Quote;
